type MapLibreGl = typeof import('maplibre-gl');

type PmtilesProtocolInstance = {
  tile: Parameters<MapLibreGl['addProtocol']>[1];
};

type PmtilesGlobal = {
  Protocol: new (options?: { metadata?: boolean }) => PmtilesProtocolInstance;
};

declare global {
  interface Window {
    pmtiles?: PmtilesGlobal;
    __doddledaysPmtilesProtocolInstalled?: boolean;
  }
}

let installation: Promise<boolean> | null = null;

export function ensurePmtilesProtocol(): Promise<boolean> {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.__doddledaysPmtilesProtocolInstalled) return Promise.resolve(true);
  if (!window.pmtiles?.Protocol) return Promise.resolve(false);
  if (installation) return installation;

  installation = import('maplibre-gl').then((module) => {
    if (window.__doddledaysPmtilesProtocolInstalled) return true;
    if (!window.pmtiles?.Protocol) return false;

    const mapLibreModule = module as MapLibreGl & { default?: MapLibreGl };
    const maplibregl = mapLibreModule.default ?? mapLibreModule;
    const protocol = new window.pmtiles.Protocol({ metadata: true });
    maplibregl.addProtocol('pmtiles', protocol.tile);
    window.__doddledaysPmtilesProtocolInstalled = true;
    return true;
  }).finally(() => {
    installation = null;
  });

  return installation;
}
